import i18n from '@/i18n'
import store from '@/store'
var firstAgo = '' // 前面
var lastAgo = '' // 后面

// 与当前时间的时间差 2分钟 前
export function updateTime(time) {
  if (time == null || time == NaN || JSON.stringify(time).indexOf('Date') != -1) return i18n.t('button.NoUpdateTime')
  if (/^[0-9]*$/.test(time)) { // 校验都是数字
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    // var dateBegin = new Date(time.replace(/-/g, '/'))// 将-转化为/，使用new Date
    var dateBegin = time // time:1570776333
    var dateEnd = new Date()// 获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin// 时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    
    var space = ' '
    
    if (store.state.language == 'de') {
      firstAgo = i18n.t('dataAndTime.ago') + ' '
      lastAgo = ''
    } else {
      firstAgo = ''
      lastAgo = i18n.t('dataAndTime.ago') + ' '
    }
    if (dayDiff == 0 && hours == 0 && minutes == 0) return i18n.t('dataAndTime.AMomentAgo')
    if (dayDiff == 0 && hours == 0) {
      if (minutes == 1) return firstAgo + minutes + space + i18n.t('dataAndTime.Min') + lastAgo
      if (minutes > 1) return firstAgo + minutes + space + i18n.t('dataAndTime.Mins') + lastAgo
    }
    if (dayDiff == 0) {
      if (hours == 1) {
        if (minutes == 1) return firstAgo + hours + space + i18n.t('dataAndTime.Hour') + space + minutes + space + i18n.t('dataAndTime.Min') + lastAgo
        if (minutes > 1) return firstAgo + hours + space + i18n.t('dataAndTime.Hour') + space + minutes + space + i18n.t('dataAndTime.Mins') + lastAgo
      } else if (hours > 1) {
        if (minutes == 1) return firstAgo + hours + space + i18n.t('dataAndTime.Hours') + space + minutes + space + i18n.t('dataAndTime.Min') + lastAgo
        if (minutes > 1) return firstAgo + hours + space + i18n.t('dataAndTime.Hours') + space + minutes + space + i18n.t('dataAndTime.Mins') + lastAgo
      }
    }

    if (dayDiff != 0) {
      if (dayDiff == 1) {
        if (hours == 0) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Day') + lastAgo
        if (hours == 1) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Day') + space + hours + space + i18n.t('dataAndTime.Hour') + lastAgo
        if (hours > 1) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Day') + space + hours + space + i18n.t('dataAndTime.Hours') + lastAgo
      }
      if (dayDiff > 1) {
        if (hours == 0) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Days') + lastAgo
        if (hours == 1) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Days') + space + hours + space + i18n.t('dataAndTime.Hour') + lastAgo
        if (hours > 1) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Days') + space + hours + space + i18n.t('dataAndTime.Hours') + lastAgo
      }
    }
    // }

    // console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数",hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");
  }
}

// 与当前时间的时间差 2分钟 前 [注：不过国际化，只有英文]
export function updateTimeOnlyEn(time) {
  if (time == null || time == NaN || JSON.stringify(time).indexOf('Date') != -1) return 'No update time'
  if (/^[0-9]*$/.test(time)) { // 校验都是数字
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    // var dateBegin = new Date(time.replace(/-/g, '/'))// 将-转化为/，使用new Date
    var dateBegin = time // time:1570776333
    var dateEnd = new Date()// 获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin// 时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    
    var space = ' '
    
    if (dayDiff == 0 && hours == 0 && minutes == 0) return 'A Moment Ago'
    if (dayDiff == 0 && hours == 0) {
      if (minutes == 1) return minutes + space + ' Min' + space + ' ago'
      if (minutes > 1) return minutes + space + ' Mins' + space + ' ago'
    }
    if (dayDiff == 0) {
      if (hours == 1) {
        if (minutes == 1) return hours + space + ' Hour ' + space + minutes + space + ' Min' + space + ' ago'
        if (minutes > 1) return hours + space + ' Hour ' + space + minutes + space + ' Mins' + space + ' ago'
      } else if (hours > 1) {
        if (minutes == 1) return hours + space + ' Hours ' + space + minutes + space + ' Min' + space + ' ago'
        if (minutes > 1) return hours + space + ' Hours ' + space + minutes + space + ' Mins' + space + ' ago'
      }
    }

    if (dayDiff != 0) {
      if (dayDiff == 1) {
        if (hours == 0) return dayDiff + space + ' Day' + space + ' ago'
        if (hours == 1) return dayDiff + space + ' Day ' + space + hours + space + ' Hour' + space + ' ago'
        if (hours > 1) return dayDiff + space + ' Day ' + space + hours + space + ' Hours' + space + ' ago'
      }
      if (dayDiff > 1) {
        if (hours == 0) return dayDiff + space + ' Days' + space + ' ago'
        if (hours == 1) return dayDiff + space + ' Days ' + space + hours + space + ' Hour' + space + ' ago'
        if (hours > 1) return dayDiff + space + ' Days ' + space + hours + space + ' Hours' + space + ' ago'
      }
    }
    // }

    // console.log(dateDiff+"时间差的毫秒数",dayDiff+"计算出相差天数",leave1+"计算天数后剩余的毫秒数",hours+"计算出小时数",minutes+"计算相差分钟数",seconds+"计算相差秒数");
  }
}

// 距今多长时间：刚刚、12分钟前、2小时前、1天前
export function howLongAgo(time, language) {
  var space = ' '
  if (time == null || time == NaN || time == '' || JSON.stringify(time).indexOf('Date') != -1) return i18n.t('dataAndTime.waitingUpdate')
  if (/^[0-9]*$/.test(time)) { // 校验都是数字
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    // var dateBegin = new Date(time.replace(/-/g, '/'))// 将-转化为/，使用new Date
    var dateBegin = time // time:1570776333
    var dateEnd = new Date()// 获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin// 时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    // console.log(' 相差 ' + dayDiff + '天 ' + hours + '小时 ' + minutes + ' 分钟' + seconds + ' 秒')
    // this.chargerTime = dayDiff + '天 ' + hours + '小时 ' + minutes + ' 分钟' + seconds + ' 秒' + '前 '
    // if (language == 'zh' || !language) {
    if (store.state.language == 'de') {
      firstAgo = i18n.t('dataAndTime.ago') + ' '
      lastAgo = ''
    } else {
      firstAgo = ''
      lastAgo = i18n.t('dataAndTime.ago') + ' '
    }
    if (dayDiff == 0 && hours == 0 && minutes <= 5) return i18n.t('dataAndTime.AMomentAgo')
    if (dayDiff == 0 && hours == 0 && minutes > 5) return firstAgo + minutes + space + i18n.t('dataAndTime.Mins') + lastAgo
    if (dayDiff == 0 && hours >= 1) {
      if (hours == 1) return firstAgo + hours + space + i18n.t('dataAndTime.Hour') + lastAgo
      if (hours > 1) return firstAgo + hours + space + i18n.t('dataAndTime.Hours') + lastAgo
    }
    if (dayDiff >= 1) {
      if (dayDiff == 1) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Day') + lastAgo
      if (dayDiff > 1) return firstAgo + dayDiff + space + i18n.t('dataAndTime.Days') + lastAgo
    }
    
  }
}

// 距今多长时间：刚刚、12分钟、2小时、1天
export function howLongAgo2(time, language) {
  var space = ' '
  if (time == null || time == NaN || JSON.stringify(time).indexOf('Date') != -1) return i18n.t('button.NoUpdateTime')
  if (/^[0-9]*$/.test(time)) { // 校验都是数字
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    // var dateBegin = new Date(time.replace(/-/g, '/'))// 将-转化为/，使用new Date
    var dateBegin = time // time:1570776333
    var dateEnd = new Date()// 获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin// 时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    // console.log(' 相差 ' + dayDiff + '天 ' + hours + '小时 ' + minutes + ' 分钟' + seconds + ' 秒')
    // this.chargerTime = dayDiff + '天 ' + hours + '小时 ' + minutes + ' 分钟' + seconds + ' 秒'
    // if (language == 'zh' || !language) {
    if (dayDiff == 0 && hours == 0 && minutes <= 5) return i18n.t('dataAndTime.AMomentAgo')
    if (dayDiff == 0 && hours == 0 && minutes > 5) return minutes + space + i18n.t('dataAndTime.Mins')
    if (dayDiff == 0 && hours >= 1) {
      if (hours == 1) return hours + space + i18n.t('dataAndTime.Hour')
      if (hours > 1) return hours + space + i18n.t('dataAndTime.Hours')
    }
    if (dayDiff >= 1) {
      if (dayDiff == 1) return dayDiff + space + i18n.t('dataAndTime.Day')
      if (dayDiff > 1) return dayDiff + space + i18n.t('dataAndTime.Days')
    }
    // }
  }
}

// 将时间戳转换成月份日期和时间 2019/10/25 15:15
export function getDateAndHour(timestamp, val) {
  function change(o) {
    if (o < 10) {
      return '0' + o
    } else {
      return o
    }
  }
  if (!timestamp) return
  var date = new Date(parseInt(timestamp)) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000  [改为：英文格式date.toLocaleString() //"22/07/2018, 07:22:13"]
  var Y = date.getFullYear() + '/'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
  var M2 = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  var D = change(date.getDate())
  var h = ' ' + change(date.getHours()) + ':'
  var m = change(date.getMinutes())
  var s = ':' + change(date.getSeconds())
  var monthArr = ['Jan ', 'Feb ', 'Mar ', 'Apr ', 'May ', 'June ', 'July ', 'Aug ', 'Sept ', 'Oct ', 'Nov ', 'Dec ']
  if (val == 'noYear') { // noYear : 不显示年  10/25  15:15
    if (store.state.language == 'en') { // Mon,Feb 29, 2016
      return monthArr[date.getMonth()] + change(date.getDate()) + h + m
    } else {
      return M + D + h + m
    }
  } else if (val == 'noTime') { // noTime : 不显示时间  2019/10/25
    if (store.state.language == 'en') {
      return monthArr[date.getMonth()] + change(date.getDate()) + ', ' + date.getFullYear()
    } else {
      return Y + M + D
    }
  } else if (val == 'onlyYearAndMonth') { // noTime : 值显示年月  2019/10
    if (store.state.language == 'en') {
      return monthArr[date.getMonth()] + ', ' + date.getFullYear()
    } else {
      return Y + M2
    }
  } else if (val == 'onlyMonthAndDay') { // onlyMonthAndDay : 只显示月和日  10/25
    if (store.state.language == 'en') {
      return monthArr[date.getMonth()] + change(date.getDate())
    } else {
      return M + D
    }
  } else if (val == 'noSecond') { // noSecond : 不显示秒  2019/10/25 15:15
    if (store.state.language == 'en') { // Mon,Feb 29, 2016
      return monthArr[date.getMonth()] + change(date.getDate()) + ', ' + date.getFullYear() + h + m
    } else {
      return Y + M + D + h + m
    }
  } else if (val == 'onlyTime') { // onlyTime : 只显示时间  15:15
    return h + m
  } else if (val == 'HourAndTime') { // HourAndTime : 显示时分秒  15:15:20
    return h + m + s
  } else {
    if (store.state.language == 'en') { // Mon,Feb 29, 2016
      return monthArr[date.getMonth()] + change(date.getDate()) + ', ' + date.getFullYear() + h + m + s
    } else {
      return Y + M + D + h + m + s
    }
  }
}

// 使用时长(时间戳 - 当前时间戳)  2分钟 1小时 3天
export function usedTimeFn(time, language) {
  var space = ' '
  if (time == null || time == NaN || JSON.stringify(time).indexOf('Date') != -1) return ''
  if (/^[0-9]*$/.test(time)) { // 校验都是数字
    // 如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
    // var dateBegin = new Date(time.replace(/-/g, '/'))// 将-转化为/，使用new Date
    var dateBegin = time // time:1570776333
    var dateEnd = new Date()// 获取当前时间
    var dateDiff = dateEnd.getTime() - dateBegin// 时间差的毫秒数
    var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000))// 计算出相差天数
    var leave1 = dateDiff % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000))// 计算出小时数
    // 计算相差分钟数
    var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000))// 计算相差分钟数
    // 计算相差秒数
    var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000)
    // console.log(dayDiff + '天 ' + hours + '小时 ' + minutes + ' 分钟' + seconds + ' 秒')
    if (language == 'zh' || !language) {
      if (dayDiff == 0 && hours == 0 && minutes == 0) return seconds + ' 秒'
      if (dayDiff == 0 && hours == 0) return minutes + ' 分钟'
      if (dayDiff == 0) return hours + '小时 ' + minutes + ' 分钟'
      if (dayDiff != 0) return dayDiff + '天 ' + hours + '小时 '
    } else if (language == 'en') {
      if (dayDiff == 0 && hours == 0 && minutes == 0) return i18n.t('dataAndTime.AMomentAgo')
      if (dayDiff == 0 && hours == 0) {
        if (minutes == 1) return minutes + space + i18n.t('dataAndTime.Min')
        if (minutes > 1) return minutes + space + i18n.t('dataAndTime.Mins')
      }
      if (dayDiff == 0) {
        if (hours == 1) {
          if (minutes == 1) return hours + space + i18n.t('dataAndTime.Hour') + space + minutes + space + i18n.t('dataAndTime.Hour')
          if (minutes > 1) return hours + space + i18n.t('dataAndTime.Hour') + space + minutes + space + i18n.t('dataAndTime.Hours')
        } else if (hours > 1) {
          if (minutes == 1) return hours + space + i18n.t('dataAndTime.Hours') + space + minutes + space + i18n.t('dataAndTime.Hour')
          if (minutes > 1) return hours + space + i18n.t('dataAndTime.Hours') + space + minutes + space + i18n.t('dataAndTime.Hours')
        }
      }

      if (dayDiff != 0) {
        if (dayDiff == 1) {
          if (hours == 1) return dayDiff + space + i18n.t('dataAndTime.Day') + space + hours + space + i18n.t('dataAndTime.Hour')
          if (hours > 1) return dayDiff + space + i18n.t('dataAndTime.Day') + space + hours + space + i18n.t('dataAndTime.Hours')
        }
        if (dayDiff > 1) {
          if (hours == 1) return dayDiff + space + i18n.t('dataAndTime.Days') + space + hours + space + i18n.t('dataAndTime.Hour')
          if (hours > 1) return dayDiff + space + i18n.t('dataAndTime.Days') + space + hours + space + i18n.t('dataAndTime.Hours')
        }
      }
    }
  }
}

// 将时间戳转换成年月日和星期 2019/10/25  星期一
export function getDateAndWeek(timestamp) {
  var space = ' '
  function change(o) {
    if (o < 10) {
      return '0' + o
    } else {
      return o
    }
  }
  if (!timestamp) return
  var date = new Date(parseInt(timestamp)) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '/'
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
  var D = change(date.getDate())
  var week
  switch (new Date(timestamp).getDay()) {
    case 0:week = i18n.t('dataAndTime.Sunday'); break
    case 1:week = i18n.t('dataAndTime.Monday'); break
    case 2:week = i18n.t('dataAndTime.Tuesday'); break
    case 3:week = i18n.t('dataAndTime.Wednesday'); break
    case 4:week = i18n.t('dataAndTime.Thursday'); break
    case 5:week = i18n.t('dataAndTime.Friday'); break
    case 6:week = i18n.t('dataAndTime.Saturday'); break
  }
  var monthArr = ['Jan ', 'Feb ', 'Mar ', 'Apr ', 'May ', 'June ', 'July ', 'Aug ', 'Sept ', 'Oct ', 'Nov ', 'Dec ']
  // console.log(store.state.language)
  if (store.state.language == 'en') { // Mon,Feb 29, 2016
    return week + ',' + monthArr[date.getMonth()] + D + ', ' + date.getFullYear()
  } else {
    return Y + M + D + space + week
    // return date.toDateString()
  }
}

// 使用时长(时间戳：毫秒 如：1111)  2分钟 1小时 3天
export function usedTime(value, val) {
  if (!value && value != 0) return
  if (value == 0) return 0
  var theTime = parseInt(value / 1000)// 需要转换的时间秒
  var m = 0// 分
  var h = 0// 小时
  var d = 0// 天
  var y = 0// 年
  if (theTime >= 60) {
    m = parseInt(theTime / 60)
    theTime = parseInt(theTime % 60)
    if (m > 60) {
      h = parseInt(m / 60)
      m = parseInt(m % 60)
      if (h > 24) {
        // 大于24小时
        d = parseInt(h / 24)
        h = parseInt(h % 24)
        if (d >= 365) { // 大于365天
          y = parseInt(d / 365)
          d = parseInt(d % 365)
        }
      }
    }
  }
  var result = ''
  if (theTime > 0 && (!val || val != 'noSecond')) {
    if (theTime == 1)result = '' + parseInt(theTime) + i18n.t('dataAndTime.Second')
    if (theTime > 1)result = '' + parseInt(theTime) + i18n.t('dataAndTime.Seconds')
    // result = '' + parseInt(theTime) + '秒'
  } else if (val == 'noSecond') {
    result = ''
  } else if (theTime == 0) {
    result = '' + 0 + i18n.t('dataAndTime.Second')
  }
  if (m > 0) {
    if (m == 1)result = '' + parseInt(m) + i18n.t('dataAndTime.Min') + result
    if (m > 1)result = '' + parseInt(m) + i18n.t('dataAndTime.Mins') + result
    // result = '' + parseInt(m) + '分' + result
  }
  if (h > 0) {
    if (h == 1)result = '' + parseInt(h) + i18n.t('dataAndTime.Hour') + result
    if (h > 1)result = '' + parseInt(h) + i18n.t('dataAndTime.Hours') + result
    // result = '' + parseInt(h) + '小时' + result
  }
  if (d > 0) {
    if (d == 1)result = '' + parseInt(d) + i18n.t('dataAndTime.Day') + result
    if (d > 1)result = '' + parseInt(d) + i18n.t('dataAndTime.Days') + result
    // result = '' + parseInt(d) + '天' + result
  }
  if (val == 'yearDay') { // 如：1年 、1年3天
    result = ''
    if (y == 1) result = '' + parseInt(y) + i18n.t('dataAndTime.Yr')
    if (y > 1) result = '' + parseInt(y) + i18n.t('dataAndTime.Yrs')
    if (d > 0) {
      if (d == 1) result += '' + parseInt(d) + i18n.t('dataAndTime.Day')
      if (d > 1) result += '' + parseInt(d) + i18n.t('dataAndTime.Days')
    }
  }
  return result
}
